import { CatalogServiceDto } from '@wix/bookings-uou-types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { EnrichedService } from '../../types/types';

export const shouldShowDummyContent = ({
  services,
  flowAPI,
}: {
  services: CatalogServiceDto[] | EnrichedService[];
  flowAPI: ControllerFlowAPI;
}): boolean => {
  const hasServices = services?.length > 0;
  return !hasServices && flowAPI.environment.isEditor;
};
